import { CratesDataSourceService } from './../../core/data-sources/crates-data-source.service';
import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormControl} from '@angular/forms';
import { ActionService } from 'src/app/core/services/action.service';

@Component({
  selector: 'app-inspection-details-product-modal',
  templateUrl: './inspection-details-product-modal.component.html',
  styleUrls: ['./inspection-details-product-modal.component.scss']
})
export class InspectionDetailsProductModalComponent implements OnInit {
  selected = new FormControl(0);
  isCommentChange = false;
  loadHistoryTab = false;

  constructor(public dialogRef: MatDialogRef<InspectionDetailsProductModalComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private cratesDataSourceService: CratesDataSourceService,
              private actionService: ActionService) { }

  ngOnInit(): void {
    this.data.crateDetails.inOrderNumber = this.data.item.inOrderNumber || '---';
    this.selected.setValue(this.data.page);

    this.dialogRef.keydownEvents().subscribe(event => {
      if (event.key === 'Escape') {
        this.close();
      }
    });

    this.dialogRef.backdropClick().subscribe(event => {
      this.close();
    });
  }

  close(event?) {
    if (this.isCommentChange || event === 'SUBMITTED') {
      this.dialogRef.close('SUBMITTED');
    } else {
      this.dialogRef.close();
    }
  }

  async v3SubmitComment(event) {
    try {
      await this.actionService.addCommentToPallet({
        crateId: this.data.item.id,
        stage: 'RECEIVED',
        text: event.comment,
        timestamp: Date.now()
      });
    } catch (e) {
      console.log(e);
    } finally {
      await this.update();
      this.isCommentChange = true;
    }
  }

  async v3DeleteComment(id) {
    try {
      await this.actionService.removePalletComment({ id });
    } catch (e) {
      console.log(e);
    } finally {
      await this.update();
      this.isCommentChange = true;
    }
  }

  async update() {
    this.data.crateDetails = await this.cratesDataSourceService.getCrateById(this.data.item.id);
  }

  onSelectedIndexChange(index: number) {
    this.selected.setValue(index);
    this.loadHistoryTab = index === 1;
  }

  onInventoryClicked(crate) {
    this.dialogRef.close({
      openPalletInventorySidenav: true,
      crate: crate
    });
  }
}
